<template>
  <div
    class="d-widget-calendar-card d-widget-list-card"
    :style="{'background-color': widget.color}"
  >
    <div class="d-widget-list-card__header">
      <div>
        <div class="d-widget-list-card-title">
          {{widget.name}}
        </div>
      </div>

      <router-link
        custom
        to="calendar"
      >
        <fts-tippy content="My Calendar">
          <div class="d-widget-list-card-action">
            <font-awesome-icon :icon="['far', 'calendar']" class="d-widget-list-card-action-icon" />
          </div>
        </fts-tippy>
      </router-link>
    </div>

    <div class="d-widget-list-card__content fts-scrollbar fts-scrollbar-overlay">
      <template v-if="!initial && loading">
        <skeleton-locus class="d-widget-locus-card" />
        <skeleton-locus class="d-widget-locus-card" />
        <skeleton-locus class="d-widget-locus-card" />
      </template>

      <template v-else-if="isResult">
        <template v-for="item in widget.group">
          <div class="d-widget-locus-card-wrapper" v-if="widgetData[item.id] && widgetData[item.id].length" :key="item.id">
            <div class="d-widget-list-card-wrapper-description" v-if="item.label">
              <template v-if="item.label === true">&nbsp;</template>
              <template v-else>{{item.label}}</template>
            </div>
            <locus-card
              v-for="(x, index) in widgetData[item.id]"
              :key="`${x.id}-${index}`"
              :modules="modules"
              :states="getStatesByModuleId(x.vectorId)"
              :widget-data="x"
              @click.native="entryView(x)"
            />
          </div>
        </template>
      </template>

      <div class="d-widget-list-card-no-result" v-else>
        No result.
      </div>
    </div>

    <div class="d-widget-overlay" v-if="initial && loading">
      <fts-spinner show :size="24" />
    </div>
  </div>  
</template>

<script>
import commons from '../../commons/commons';
import LocusCard from './LocusCard';
import SkeletonLocus from '../../elements/skeleton-screen/dashboard/SkeletonLocus';
import FTSSpinner from '../../elements/FTSSpinner';
import FTSTippy from '../../elements/FTSTippy';

export default {
  props: {
    modules: Array,
    states: Array,
    widget: Object,
    widgetData: Object,
    loading: Boolean,
    initial: Boolean
  },
  components: {
    "locus-card": LocusCard,
    "skeleton-locus": SkeletonLocus,
    "fts-spinner": FTSSpinner,
    "fts-tippy": FTSTippy
  },
  methods: {
    entryView(item) {
      if (commons.elementStopPropagation()) return;
      this.$emit("entry:view", { id: item.id, vectorId: item.vectorId});
    },
    getStatesByModuleId(moduleId) {
      return this.states.filter(x => x.module == moduleId);
    }
  },
  computed: {
    isResult() {
      return Array.isArray(this.widget && this.widget.group) ?
        this.widget.group.some((x) => this.widgetData[x.id] && this.widgetData[x.id].length) :
        false
      ;
    }
  }
}
</script>

<style lang="scss" scoped>
@use "./src/components/dashboard/widgets/scss/style";

.d-widget-calendar-card {
  background-color: var(--fts-dashboard-calendar);
}
</style>